__turbopack_context__.v({
  "collapsed": "V2EntriesPicker-module__DVJMEq__collapsed",
  "editNumberOverlay": "V2EntriesPicker-module__DVJMEq__editNumberOverlay",
  "entriesContainer": "V2EntriesPicker-module__DVJMEq__entriesContainer",
  "entryPickerContainer": "V2EntriesPicker-module__DVJMEq__entryPickerContainer",
  "entryWrapper": "V2EntriesPicker-module__DVJMEq__entryWrapper",
  "stackItem--1": "V2EntriesPicker-module__DVJMEq__stackItem--1",
  "stackItem--2": "V2EntriesPicker-module__DVJMEq__stackItem--2",
  "stackItem--3": "V2EntriesPicker-module__DVJMEq__stackItem--3",
  "summariseEntries": "V2EntriesPicker-module__DVJMEq__summariseEntries",
});
